<template>
  <div>
    <label class="text-xs font-medium text-gray-600" v-if="label">
      {{ label }}
      <span v-if="required" class="text-red-700">*</span>
    </label>

    <v-text-field
      ref="inputRef"
      v-model="internalValue"
      :placeholder="placeholder"
      :variant="variant"
      :density="density"
      :hide-details="hideDetails"
      :color="color"
      :rules="rules"
      :bg-color="bgColor"
      :prependInnerIcon="prependInnerIcon"
      :disabled="disabled"
      :clearable="clearable"
      :type="type"
      :min="min"
      :max="max"
      :step="step"
      @keyup.enter="$emit('keyup.enter')"
      @click:clear="$emit('click:clear')"
      @blur="$emit('blur')"
    />
  </div>
</template>

<script>
export default {
  name: "FormInput",
  props: {
    label: { type: String },
    placeholder: { type: String, default: "" },
    modelValue: { type: [String, Number], default: "" },
    required: { type: Boolean, default: false },
    variant: { type: String, default: "outlined" },
    density: { type: String, default: "compact" },
    hideDetails: { type: String, default: "auto" },
    color: { type: String, default: "#475569" },
    bgColor: { type: String },
    prependInnerIcon: { type: String },
    disabled: { type: Boolean, default: false },
    rules: { type: Array, default: () => [] },
    clearable: { type: Boolean, default: false },
    type: { type: String, default: "text" },
    /** Untuk `type="number"`: diteruskan ke input (bantu browser + spin button). */
    min: { type: [String, Number], default: undefined },
    max: { type: [String, Number], default: undefined },
    step: { type: [String, Number], default: undefined },
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  emits: ["update:modelValue", "keyup.enter", "click:clear", "input", "blur", "focus"],
  methods: {
    validate() {
      return this.$refs.inputRef?.validate();
    },
    resetValidation() {
      return this.$refs.inputRef?.resetValidation();
    },
  },
};
</script>
